import Timeline from '../../chart/timeline';
import BaselineChart from '../../baselines/chart';

export default instance => {
  instance.attachEvent('onBeforeGanttRender', () => {
    Timeline.updateTimeScaleRange();
    BaselineChart.onBeforeGanttRender();
  });
};
